export enum AlgorithmType {
  MPoRT = 'MPoRT Life Expectancy',
  RESPECT = 'RESPECT'
}
